// Global Namespace
var NP = NP || {},
	Viewer, // For Image Viewer
	imgUploadG, // For Image Upload
	profileImgUploadG; // For Profile Image Upload


// Pre-declare
NP.doc = jQuery( document );
NP.win = jQuery( window );
NP.body = jQuery( 'body' );
NP.container = jQuery( '#sb-ex-guestbook' );
NP.contents = jQuery( '#contents' );
NP.isLoading = !1;

if( !NP.container.length ) NP.container = jQuery( '#wrapContainer' );
if( !NP.container.length ) NP.container = jQuery( '#wrap_container' );
if( !NP.contents.length ) NP.contents = jQuery( '#wrapTimeline' );

NP.timeline = NP.contents.find( '.wrap_timeline' );
//NP.Debug = true; // Debug


// UI페이지용
/*if ( !NP.dt ) {
	NP.dt = {
		v : '03AB2347-953A-E111-A3A8-18A90577F91B',
		vNm : '일리터의콧물',
		o : '03AB2347-953A-E111-A3A8-18A90577F91B',
		oNm : '일리터의콧물',
		page : 'timeline',
		loc : '',
		st : 'bns'
	};
}*/


// Callbacks
NP.onDomLoad = jQuery.Callbacks();
NP.onBeforeGetTimeline = jQuery.Callbacks();
NP.onAfterTimelineLoad = jQuery.Callbacks();
NP.onProcessing = jQuery.Callbacks();
NP.onProcessingReply = jQuery.Callbacks();


// Hosts
NP.STATIC_URL = 'https://wstatic-cdn.plaync.com/';
NP.RESOURCE_URL = NP.STATIC_URL + 'resource/sandbox/';
// NP.SFILE_URL = 'http://dn.sfile.plaync.com/';
NP.SFILE_URL = 'https://profileimg.plaync.com/';
NP.FILESVR_URL = 'https://imgfiles.plaync.com/file/SNS/';
NP.FILESVR_PROFILE_URL = 'https://imgfiles.plaync.com/file/ProfileImage/';
NP.leaderboard = 'https://bns.plaync.com/bs/leaderboard/duel';
NP.rc = '';

if ( /^dev\./.test( location.hostname ) ){
	NP.STATIC_URL = 'http://static.plaync.co.kr/';
	NP.RESOURCE_URL = NP.STATIC_URL + 'resource/sandbox/';
	NP.SFILE_URL = 'http://dev.profileimg.plaync.com/';
	NP.FILESVR_URL = 'http://dev.imgfiles.plaync.com/file/SNS/';
	NP.FILESVR_PROFILE_URL = 'http://dev.imgfiles.plaync.com/file/ProfileImage/';
	NP.leaderboard = 'http://dev.bns.plaync.com/bs/leaderboard/duel';
}

if ( /rc\.|rc\-/.test( location.host ) ) {
	NP.rc = 'rc.';
	NP.STATIC_URL = 'https://rc-wstatic.plaync.co.kr/';
	NP.RESOURCE_URL = NP.STATIC_URL + 'resource/sandbox/';
	NP.SFILE_URL = 'https://rc-profileimg.plaync.com/';
	NP.FILESVR_URL = 'https://rc-imgfiles.plaync.com/file/SNS/';
	NP.FILESVR_PROFILE_URL = 'https://rc-imgfiles.plaync.com/file/ProfileImage/';
	NP.leaderboard = 'https://rc-bns.plaync.com/bs/leaderboard/duel';
}
NP.SANDBOX_URL = NP.STATIC_URL + 'sandbox/';

NP.aionUrl = 'aion.plaync.com';
//NP.aionUrl = 'aionver2.plaync.com';
NP.bnsUrl = 'bns.plaync.com';
NP.sandboxUrl = 'sandbox.plaync.com';
NP.gamePicUrl = 'gamepic.plaync.com';


// Namespace
NP.ns = function( ns ) {
	var parts = ns.split( '.' ),
		parent = NP,
		len,
		i;

	if ( parts[ 0 ] === 'NP' ) {
		parts = parts.slice( 1 );
	}

	for ( i = 0, len = parts.length; i < len; i += 1 ) {
		if ( typeof parent[ parts[ i ] ] === 'undefined' ) {
			parent[ parts[ i ] ] = [];
		}

		parent = parent[ parts[ i ] ];
	}

	return parent;
};
